import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _typeof from "D:/work/Code/\u9676\u51B6/new_hundred_web_ts/hundred_web_ts/node_modules/@babel/runtime/helpers/esm/typeof";
import { __values } from "tslib";
import { isUndef, dateNow, dateParse } from '@/lib/utils'; // 是否支持存储数据

var supportLocalStorage = !isUndef(window.localStorage);
export var isSupport = supportLocalStorage;
var localStorage = window.localStorage; // tip: 为了单元测试能够正常运行

/**
 * 判断是否过期
 *
 * @param {String} time 日期
 *
 * @return {} 是否已经过期
 */

function isExpire(time) {
  return dateParse(time).valueOf() < dateNow().valueOf();
}
/**
 * 获得数据
 *
 * @param {} key
 *
 * @return {} 结果内容
 */


export function get(key) {
  if (!supportLocalStorage) {
    return null;
  } // 判断是否存在expire


  var exp = getExpire(key);

  if (!isUndef(exp) && isExpire(exp)) {
    // 如果发现过期数据，那么删除数据和过期时间
    del(key);
    del('_e_' + key);
  }

  var result = localStorage.getItem(key);
  return result;
}
/**
 * 获得expire时间
 *
 * @param {} key
 * @return {string | null}
 */

export function getExpire(key) {
  if (!supportLocalStorage) {
    return null;
  }

  return localStorage.getItem('_e_' + key);
}
/**
 * 设置数据
 *
 * @param {} key
 * @param {} value 允许string/number/object，对object将进行JSON.stringify
 */

export function set(key, value) {
  if (!supportLocalStorage) {
    return;
  }

  var result = '';

  if (typeof value === 'string') {
    result = value;
  } else if (typeof value === 'number') {
    result = value + '';
  } else if (_typeof(value) === 'object') {
    result = JSON.stringify(value);
  }

  localStorage.setItem(key, result);
}
/**
 * 标记过期数据
 *
 * @param {} key
 * @param {} expire 过期时间
 */

export function expire(key, exp) {
  if (!supportLocalStorage) {
    return;
  }

  set('_e_' + key, exp);
}
/**
 * 设置数据，包括expire
 *
 * @param {string} key
 * @param {any} value
 * @param {} exp 过期时间,例如2019-01-01
 */

export function setex(key, value, exp) {
  if (!supportLocalStorage) {
    return;
  }

  set(key, value);

  if (exp) {
    expire(key, exp);
  }
}
/**
 * 删除数据
 */

export function del(key) {
  if (!supportLocalStorage) {
    return;
  }

  localStorage.removeItem(key);
}
/**
 * 支持普通的key也支持path
 * @param {} exp 过期时间,例如2019-01-01
 */

export function pathSet(keyOrPath, value, exp) {
  var e_1, _a;

  if (!supportLocalStorage) {
    return;
  }

  var parts = keyOrPath.split('.');

  if (parts.length === 1) {
    if (exp) {
      setex(keyOrPath, value, exp);
    } else {
      set(keyOrPath, value);
    }
  } else {
    var first = parts.shift();
    var last = parts.pop();
    var storeValue = get(first) || '{}';
    var obj = JSON.parse(storeValue);
    var traverse = obj;

    try {
      for (var parts_1 = __values(parts), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
        var part = parts_1_1.value; // 寻找失败

        if (!traverse[part]) {
          traverse[part] = {};
        }

        if (_typeof(traverse[part]) !== 'object') {
          return;
        }

        traverse = traverse[part];
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (parts_1_1 && !parts_1_1.done && (_a = parts_1["return"])) _a.call(parts_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    traverse[last] = value;

    if (exp) {
      setex(first, obj, exp);
    } else {
      set(first, obj);
    }
  }
}
export function pathDel(keyOrPath) {
  var e_2, _a;

  if (!supportLocalStorage) {
    return;
  }

  var parts = keyOrPath.split('.');

  if (parts.length === 1) {
    del(keyOrPath);
  } else {
    var first = parts.shift();
    var last = parts.pop();
    var storeValue = get(first) || '{}';
    var obj = JSON.parse(storeValue);
    var traverse = obj;

    try {
      for (var parts_2 = __values(parts), parts_2_1 = parts_2.next(); !parts_2_1.done; parts_2_1 = parts_2.next()) {
        var part = parts_2_1.value; // 寻找失败

        if (!traverse[part]) {
          traverse[part] = {};
        }

        if (_typeof(traverse[part]) !== 'object') {
          return;
        }

        traverse = traverse[part];
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (parts_2_1 && !parts_2_1.done && (_a = parts_2["return"])) _a.call(parts_2);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    delete traverse[last];
    var exp = getExpire(first);

    if (exp) {
      setex(first, obj, exp);
    } else {
      set(first, obj);
    }
  }
}
export function pathGet(keyOrPath) {
  var e_3, _a;

  if (!supportLocalStorage) {
    return;
  }

  var parts = keyOrPath.split('.');

  if (parts.length === 1) {
    return get(keyOrPath);
  } else {
    var first = parts.shift();
    var last = parts.pop();
    var storeValue = get(first) || '{}';
    var traverse = JSON.parse(storeValue);

    try {
      for (var parts_3 = __values(parts), parts_3_1 = parts_3.next(); !parts_3_1.done; parts_3_1 = parts_3.next()) {
        var part = parts_3_1.value;
        traverse = traverse[part]; // 寻找失败

        if (!traverse || _typeof(traverse) !== 'object') {
          return;
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (parts_3_1 && !parts_3_1.done && (_a = parts_3["return"])) _a.call(parts_3);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    return traverse[last];
  }
}
/**
 * 获得sessionStorage的数据
 *
 * @param {} key
 *
 * @return {} 结果内容
 */

export function getSessionStorage(key) {
  var result = sessionStorage.getItem(key);
  return result;
}
/**
 * 设置sessionStorage数据
 *
 * @param {} key
 * @param {} value
 */

export function setSessionStorage(key, value) {
  sessionStorage.setItem(key, value);
}
/**
 * 删除sessionStorage的数据
 *
 * @param {} key
 *
 * @return {} 结果内容
 */

export function delSessionStorage(key) {
  var result = sessionStorage.removeItem(key);
  return result;
}